import { addDays } from 'date-fns';
import { ContestStatus } from '~/models/contest-status';

// 応募の開催が現在の日時より前もしくは、開始から14日以内の場合に新着アイコンを表示する
export const shouldShowNew = ({
  openEntryAt,
  status,
}: {
  openEntryAt?: Date;
  status: ContestStatus;
}) => {
  // openEntryAt が存在しない場合は false を返す
  if (!openEntryAt) {
    return false;
  }
  // ステータスが告知中または応募受付中でない場合は false を返す
  if (
    !(
      status === 'CONTEST_STATUS_DISCLOSED' ||
      status === 'CONTEST_STATUS_OPENED'
    )
  ) {
    return false;
  }

  const now = new Date();
  const fourteenDaysLater = addDays(openEntryAt, 14);

  return (
    now.getTime() < openEntryAt.getTime() || // 応募開始前
    now.getTime() < fourteenDaysLater.getTime() // 14日以内
  );
};
